module.exports = __webpack_public_path__ + "img/6-reference-highlighted.84891224.webp";